/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
function i(e, t) {
  let r = e;
  for (; r && r !== t; )
    r = r.parentNode;
  return !!r;
}
function l(e, t, r, a) {
  const n = e[t];
  if (n && Array.isArray(n)) {
    for (const o of n)
      if (!o.type || o.type !== a)
        return new Error(`${r} children should be Array of type ${a.displayName}.`);
  }
  return null;
}
export {
  i as hasParent,
  l as validateChildren
};
